export default __webpack_public_path__ + "static/media/ic-edit.e712e242.svg";